"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompressMode = void 0;
var CompressMode;
(function (CompressMode) {
    /**
     * The save is not zipped at all
     */
    CompressMode[CompressMode["Unzipped"] = 0] = "Unzipped";
    /**
     * There's a meta file duplicating information for faster reading
     */
    CompressMode[CompressMode["Duplicate"] = 1] = "Duplicate";
    /**
     * Game information is split up into many files that should be merged into one
     */
    CompressMode[CompressMode["Split"] = 2] = "Split";
})(CompressMode = exports.CompressMode || (exports.CompressMode = {}));
